import React, {forwardRef} from 'react'
import {ComboboxInputProps} from '../../components/Combobox/types'
import TextInputInnerVisualSlot from '../../components/TextInput/TextInputInnerVisualSlot'

import AutocompleteInputWrapper from './_AutocompleteInputWrapper'
import {AutocompleteUnstyledInput} from './_AutocompleteUnstyledInput'
import {useRefObjectAsForwardedRef} from '../..'

const fontSize = () => 14

export interface AutocompleteInputProps extends ComboboxInputProps {
  children?: React.ReactNode
  /** A short hint that describes the expected value of an input field */
  placeholder?: string
  /** A visual that renders inside the input before the typing area */
  leadingVisual?: string | React.ComponentType<React.PropsWithChildren<{className?: string}>>
  /** Whether the to show a loading indicator in the input */
  loading?: boolean
}
/**  */
const AutocompleteInput = forwardRef(
  ({leadingVisual: LeadingVisual, placeholder, loading, ...props}: AutocompleteInputProps, forwardedRef) => {
    const innerRef = React.useRef<HTMLInputElement>(null)
    useRefObjectAsForwardedRef(forwardedRef, innerRef)
    const showLeadingLoadingIndicator = loading

    return (
      <AutocompleteInputWrapper
        hasLeadingVisual={Boolean(LeadingVisual || showLeadingLoadingIndicator)}
        aria-live="polite"
        aria-busy={Boolean(loading)}
      >
        <TextInputInnerVisualSlot
          visualPosition="leading"
          showLoadingIndicator={showLeadingLoadingIndicator}
          hasLoadingIndicator={typeof loading === 'boolean'}
        >
          {typeof LeadingVisual === 'function' ? <LeadingVisual /> : LeadingVisual}
        </TextInputInnerVisualSlot>
        <AutocompleteUnstyledInput ref={innerRef} placeholder={placeholder} />
      </AutocompleteInputWrapper>
    )
  }
)
AutocompleteInput.displayName = 'CustomComboboxInput'
export default AutocompleteInput
